import { render, staticRenderFns } from "./ShippingCharge.vue?vue&type=template&id=57871424"
import script from "./ShippingCharge.vue?vue&type=script&lang=js"
export * from "./ShippingCharge.vue?vue&type=script&lang=js"
import style0 from "./ShippingCharge.vue?vue&type=style&index=0&id=57871424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports